import React from 'react';
import './BlogPost.css';

import logo1 from '../../images/wennewick.jpg'

class BlogPost0 extends React.Component {
  render() {
    return (
    <div className="blogpost-outer">
      <div className="blogpost-title">
        <h3 className="blogpost-h3" >Schützenfest in Wennewick!     -     11. Mai 2018</h3>
      </div>
      <div className="blogpost-content">
        <div className="blogpost-image">
          <img className="image-fit" alt="Schützenfest in Wennewick" src={logo1} />
        </div>
        <div className="blogpost-text">
          Nach einem super ersten Abend auf dem Schützenfest Wennewick geht’s gleich weiter! Wir freuen uns! 
        </div>

      </div>
    </div>
    )
  }
}

export default BlogPost0;


// WEBPACK FOOTER //
// ./src/components/blog/BlogPost0.js